require('./bootstrap');
require('./axiosSetup');

import Vue from 'vue';

//Rutas del website
import Router from './router.js';
import moment from 'moment';
moment.locale('es');
import { store } from './store/state-loader.js'
import _ from 'lodash'

import * as ToolFilters from './components/page/daniel/tools/filters';

Vue.filter('msisdnToPhone', ToolFilters.msisdnToPhone);
Vue.filter('mb2gb', ToolFilters.mb2gb);
Vue.filter('altanFixLabel', ToolFilters.altanFixLabel);
Vue.filter('suscriptionStatusReNamer', ToolFilters.suscriptionStatusReNamer);
Vue.filter('suscriptionStatusLabel', ToolFilters.suscriptionStatusReNamer);
Vue.filter('img', ToolFilters.makeImage);

// HAND MADE FILTERS
Vue.filter('humanizar_fecha', (value) => {
	moment.locale('es');
	try {
		let date = moment(value, 'YYYY-MM-DD', true),
			formatted = '';
		if (date.isValid()) {
			formatted = date.format("dddd D [de] MMMM [del] YYYY");
		} else {
			formatted = moment(value).format("dddd D [de] MMMM [del] YYYY");
		}
		return formatted.charAt(0).toUpperCase() + formatted.slice(1).toLocaleLowerCase();
	} catch(e){
		return '--';
	}
});

// HAND MADE FILTERS
Vue.filter('humanizar_fecha_altan', (value) => {
	moment.locale('es');
	// return moment(value).format("dddd D [de] MMMM, YYYY");
	return (!!value) ? moment(value, 'YYYYDDMMhhmmss').format("dddd D [de] MMMM [del] YYYY, h:mm:ss a") : '--';
});

//Librerias globales
import Library from './libs.js';
Vue.use(Library);

//Componentes del website
import components from './components/components.js';
import { mapActions } from 'vuex';
Vue.use(components);

window.Vue = Vue;

//Instancia principal
const app = new Vue({
	el: '#app',
	router: Router,

	data() {
		return {
			logged: true,
			catalogsIsLoaded: false,

			// == Paquetes ==
			planMovil: _.map([
				{
					id: 1,
					img: 'public/images/pages/home/cometa.png',
					nChars: 1,
					days: '3 días',
					gbs: '4 GB',
					hotspot: false,
					planName: 'COMETA',
					amount: 33,
					descr: `<p>2000 MB NORMAL<br />2000 MB VEL REDUCIDA<br />250 MINUTOS Y 125 SMS</p>`,
				},
			], pck => {
				pck.price = "$" + pck.amount.toFixed(2) + " MXN";
				return pck
			}),

			planMifi: [
				{
					id: 1,
					nChars: 2,
					days: '7 días',
					gbs: '10 GB',
					planName: 'SKY7D 10',
					amount: 95,
					price: '$95.00 MXN',
					descr: `<p>10 GB A LA MEJOR VELOCIDAD  DE LA RED POR 7 DIAS</p>`,
				}
			],

			planCasa: [
				{
					id: 1,
					nChars: 2,
					days: '30 días',
					gbs: '30 GB',
					planName: 'SKYHOME 30 5MB',
					amount: 150,
					price: '$150.00 MXN',
					descr: `<p>30 GB ALA MEJOR VELOCIDAD<br />+ 40 GB NOCTURNOS</p>`,
				}
			],
			// == fin paquetes ==

			// == Opciones de Carruseles de paquetes ==
			swPackOpts: {
				slidesPerView: 3,
				spaceBetween: 0,

				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},

				breakpoints: {
					1300: {
						slidesPerView: 3,
					},
					768: {
						slidesPerView: 2,
					},
					1: {
						slidesPerView: 1,
					},
				}
			},
			// == fin opciones ==
		}
	},

	async beforeMount() {
		// let openPayIsSandbox = false
		// $(()=>{
		// 	if(typeof OpenPay == 'function'){
		// 		console.log('OpenPay loaded')

		// 		// OPENPAY CONFIG
		// 		if(!openPayIsSandbox){
		// 			OpenPay.setId('');
		// 			OpenPay.setApiKey('');
		// 			// OpenPay.setSandboxMode( false ); // Si está en producción, esta función da problemas aunque se pase en false. (Bug de openpay)
		// 		} else {
		// 			// pagostesting@blackfon.online
		// 			OpenPay.setId('');
		// 			OpenPay.setApiKey('');
		// 			OpenPay.setSandboxMode( true );
		// 			alert('Is Sandbox!')
		// 		}
		// 	} else {
		// 		console.error('No cargó el objeto OpenPay')
		// 	}
		// })
		this.catalogsIsLoaded = false
		await Promise.all([
			this.authLoadUp(),
			this.catalogosLoadUp(),
			this.OfertasPublicasRefresh(),
			this.cartReadFromLocal()
		])
		this.catalogsIsLoaded = true
	},

	async mounted() {
		const timeout = 1000;
		setTimeout(async () => {
			// await this.uiLoadUp(this.$route.query)
			this.loadScript("https://js.stripe.com/v3/")
			// this.isLoading = false;
		}, timeout);
	},

	methods: {
		...mapActions(['catalogosLoadUp', 'authLoadUp', 'OfertasPublicasRefresh', 'cartReadFromLocal']),
		loadScript(scriptURI) {
			// This is necessary to force Vue to insert the cordova.js plugin.
			var script = document.createElement("script");
			script.setAttribute("src", scriptURI);
			script.setAttribute("type", "text/javascript");
			document.getElementsByTagName("head")[0].appendChild(script);
			// console.log("loadScript", scriptURI)
		},

		noPaste(evt) {
			// evt.preventDefault();
		},

		isNumber: function (evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if (charCode < 48 || charCode > 57) {
				evt.preventDefault();
			} else {
				return true;
			}
		}

	},

	store

});
